import React, { Fragment } from 'react'

import PropTypes from 'prop-types'

import './carousel.css'

const Carousel = (props) => {
  return (
    <div className={`carousel-container10 ${props.rootClassName} `}>
      <div className="carousel-container11">
        <h1 className="carousel-text10">
          {props.heading ?? (
            <Fragment>
              <span className="carousel-text21">Sydrisworx</span>
            </Fragment>
          )}
        </h1>
        <div className="carousel-container12">
          <span className="carousel-text11">
            {props.text7 ?? (
              <Fragment>
                <span className="carousel-text16">
                  With a keen focus on collaboration, empowerment, and walking
                  the journey with our partners, we provide end-to-end data
                  solutions, strategic advisory services, and skills development
                  to drive business value in the digital age.
                </span>
              </Fragment>
            )}
          </span>
        </div>
      </div>
      <div className="carousel-container13">
        <div className="carousel-container14">
          <div className="carousel-container15">
            <img
              alt={props.imageAlt10}
              src={props.imageSrc10}
              className="carousel-image1"
            />
          </div>
          <div className="carousel-container16">
            <div className="carousel-container17">
              <span className="carousel-text12">
                {props.text611 ?? (
                  <Fragment>
                    <span className="carousel-text19">
                      Cloud solutions tailored to optimise your
                      organisation&apos;s needs.
                    </span>
                  </Fragment>
                )}
              </span>
              <a
                href="https://www.ibm.com/think/cloud"
                target="_blank"
                rel="noreferrer noopener"
                className="carousel-link1 button"
              >
                <span>
                  {props.button ?? (
                    <Fragment>
                      <span className="carousel-text17">Read More...</span>
                    </Fragment>
                  )}
                </span>
              </a>
            </div>
          </div>
        </div>
        <div className="carousel-container18">
          <div className="carousel-container19">
            <img
              alt={props.imageAlt9}
              src={props.imageSrc9}
              className="carousel-image2"
            />
          </div>
        </div>
        <div className="carousel-container20">
          <div className="carousel-container21">
            <img
              alt={props.imageAlt11}
              src={props.imageSrc11}
              className="carousel-image3"
            />
          </div>
          <div className="carousel-container22">
            <div className="carousel-container23">
              <span className="carousel-text14">
                {props.text6112 ?? (
                  <Fragment>
                    <span className="carousel-text18">
                      The future is African
                    </span>
                  </Fragment>
                )}
              </span>
              <a
                href="https://storage.googleapis.com/playground-bucket-v2.teleporthq.io/e0b7ceef-2f65-424f-bf17-77e7942f6aee/d003c501-85ea-475f-8984-4a0de3dc0519"
                target="_blank"
                rel="noreferrer noopener"
                className="carousel-link2 button"
              >
                <span>
                  {props.button2 ?? (
                    <Fragment>
                      <span className="carousel-text20">Read More...</span>
                    </Fragment>
                  )}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

Carousel.defaultProps = {
  imageSrc11: '/12-1500w.png',
  text7: undefined,
  imageSrc9: '/31-1500w.png',
  imageSrc10: '/21-1500w.png',
  button: undefined,
  text6112: undefined,
  text611: undefined,
  imageAlt9: 'image',
  rootClassName: '',
  button2: undefined,
  heading: undefined,
  imageAlt11: 'image',
  imageAlt10: 'image',
}

Carousel.propTypes = {
  imageSrc11: PropTypes.string,
  text7: PropTypes.element,
  imageSrc9: PropTypes.string,
  imageSrc10: PropTypes.string,
  button: PropTypes.element,
  text6112: PropTypes.element,
  text611: PropTypes.element,
  imageAlt9: PropTypes.string,
  rootClassName: PropTypes.string,
  button2: PropTypes.element,
  heading: PropTypes.element,
  imageAlt11: PropTypes.string,
  imageAlt10: PropTypes.string,
}

export default Carousel
